export default {
    'input_options': {
        'countries': [
            {
                'label': 'Australia',
                'tax_lower': 0.235,
                'tax_higher': 0.235,
                'discount': 0.4,
                'description': 'In Australia, startups typically use stock options to reward talent. When employees exercise, they are not taxed. Under special schemes, when they sell their shares later, total upside is taxed at reduced rates (23.5%).',
                'id': 'australia',
            },
            {
                'label': 'Austria',
                'tax_lower': 0.4586,
                'tax_higher': 0.5,
                'discount': 1,
                'description': 'In Austria, startups most often use virtual stock options to reward talent. When employees receive a cash benefit, the upside is taxed as income (up to 50%).',
                'id': 'austria',
            },
            {
                'label': 'Belgium',
                'tax_lower': 0.0418,
                'tax_higher': 0.045,
                'discount': 1,
                'description': 'In Belgium, startups most often use warrants to reward talent. When employees are granted warrants, 9% or 18% of the value of shares is taxed as income (up to 50%), which is a strong disincentive for receiving options in the first place. There is not usually any further taxation at exercise or sale.',
                'id': 'belgium',
            },
            {
                'label': 'Canada',
                'tax_lower': 0,
                'tax_higher': 0,
                'discount': 0.4,
                'description': 'In Canada, startups typically use stock options to reward talent. Employees are not taxed when they exercise. When they sell their shares later, total upside is taxed 50% of the employee\'s marginal rate. If sale is more than 2 years after exercise, up to C$850k is entirely tax free.',
                'id': 'canada',
            },
            {
                'label': 'Czech Republic',
                'tax_lower': 0.311,
                'tax_higher': 0.311,
                'discount': 1,
                'description': 'In the Czech Republic, startups most often use virtual stock options to reward talent. When employees receive a cash benefit, the upside is taxed as income (up to 34%).',
                'id': 'czech-republic',
            },
            {
                'label': 'Denmark',
                'tax_lower': 0.472,
                'tax_higher': 0.565,
                'discount': 1,
                'description': 'In Denmark, startups typically use warrants to reward talent. When employees exercise, the upside is taxed as income (up to 56.5%). If they sell their shares later separately, additional upside is taxed as a capital gain (up to 42%).',
                'id': 'denmark',
            },
            {
                'label': 'Estonia',
                'tax_lower': 0.2,
                'tax_higher': 0.2,
                'discount': 0.4,
                'description': 'In Estonia, startups typically use stock options to reward talent. Employees are not taxed when they exercise. When they sell their shares later, total upside is taxed at flat income rates (20%). Strike prices 60% below last-round valuation are common.',
                'id': 'estonia',
            },
            {
                'label': 'Finland',
                'tax_lower': 0.4428,
                'tax_higher': 0.5105,
                'discount': 1,
                'description': 'In Finland, startups typically use stock options to reward talent. When employees exercise, the upside is taxed as income (up to 55%). If they sell their shares later separately, additional upside is taxed as a capital gain (up to 34%).',
                'id': 'finland',
            },
            {
                'label': 'France',
                'tax_lower': 0.362,
                'tax_higher': 0.362,
                'discount': 0.8,
                'description': 'In France, startups typically use BSPCE\'s to reward talent. When employees exercise, they are not taxed. When they sell their shares later, total upside is taxed at special taxation rates of 34.5% or 45.5%.',
                'id': 'france',
            },
            {
                'label': 'Germany',
                'tax_lower': 0.5776,
                'tax_higher': 0.6431,
                'discount': 1,
                'description': 'In Germany, startups most often use virtual stock options to reward talent. When employees receive a cash benefit, the upside is taxed as income (up to 64%).',
                'id': 'germany',
            },
            {
                'label': 'Ireland',
                'tax_lower': 0.3205,
                'tax_higher': 0.3205,
                'discount': 1,
                'description': 'In Ireland, startups typically use stock options to reward talent. With the KEEP scheme, introduced in January 2018, employees are not taxed when they exercise. When they sell their shares later, total upside is taxed as a capital gain (up to 33%).',
                'id': 'ireland',
            },
            {
                'label': 'Israel',
                'tax_lower': 0.25,
                'tax_higher': 0.25,
                'discount': 0.4,
                'description': 'In Israel, startups typically use stock options to reward talent. Employees are not taxed when they exercise. When they sell their shares later, total upside is taxed as a capital gain (25%). Strike prices 60% below last-round valuation are common.',
                'id': 'israel',
            },
            {
                'label': 'Italy',
                'tax_lower': 0.26,
                'tax_higher': 0.26,
                'discount': 1,
                'description': 'In Italy, startups typically use stock options to reward talent. With the Innovative Startups scheme, employees are not taxed when they exercise. When they sell their shares later, total upside is taxed as a capital gain (26%).',
                'id': 'italy',
            },
            {
                'label': 'Latvia',
                'tax_lower': 0.2,
                'tax_higher': 0.2,
                'discount': 1,
                'description': 'In Latvia, startups typically use stock options to reward talent. As of 2021, employee grants are not taxed when they exercise. When they sell their shares later, total upside is taxed at flat income rates (20%). Strike prices can be as low as nominal share price, at the company&rsquo;s discretion.',
                'id': 'latvia',
            },
            {
                'label': 'Lithuania',
                'tax_lower': 0.2,
                'tax_higher': 0.2,
                'discount': 1,
                'description': 'In Lithuania, startups typically use stock options to reward talent. As of 2021, employee grants are not taxed when they exercise. When they sell their shares later, total upside is taxed at flat income rates (20%). Strike prices can be as low as nominal share price, at the company&rsquo;s discretion.',
                'id': 'lithuania',
            },
            {
                'label': 'Netherlands',
                'tax_lower': 0.3292,
                'tax_higher': 0.3896,
                'discount': 1,
                'description': 'In the Netherlands, startups most often use warrants to reward talent. When employees exercise, the upside is taxed as income (up to 52%). There is no additional tax to pay if shares are later sold.',
                'id': 'netherlands',
            },
            {
                'label': 'Norway',
                'tax_lower': 0.4526,
                'tax_higher': 0.466,
                'discount': 0.8,
                'description': 'In Norway, startups often use tailored share purchase plans to reward talent. When employees acquire shares, they are taxed as income (up to 46.6%).  If they sell their shares later separately, additional upside is taxed as a capital gain (30.6%).',
                'id': 'norway',
            },
            {
                'label': 'Poland',
                'tax_lower': 0.19,
                'tax_higher': 0.19,
                'discount': 1,
                'description': 'In Poland, startups typically use stock options to reward talent. When employees exercise, they are not taxed. When they sell their shares later, total upside is taxed as a capital gain (19%).',
                'id': 'poland',
            },
            {
                'label': 'Portugal',
                'tax_lower': 0.14,
                'tax_higher': 0.14,
                'discount': 1,
                'description': 'In Portugal, startups most often use virtual stock options to reward talent. When employees receive a cash benefit, the upside is taxed as a capital gain (at 14% or 28%).',
                'id': 'portugal',
            },
            {
                'label': 'Spain',
                'tax_lower': 0.5135,
                'tax_higher': 0.5135,
                'discount': 1,
                'description': 'In Spain, startups typically use SARs to reward talent, which are a form of virtual stock option. When employees receive a cash benefit, the upside is taxed as income (up to 54.4%).',
                'id': 'spain',
            },
            {
                'label': 'Sweden',
                'tax_lower': 0.25,
                'tax_higher': 0.25,
                'discount': 0.2,
                'description': 'In Sweden, startups with under 50 employees use stock options to reward talent. With the new QESO scheme, when employees exercise, they are not taxed. When they sell their shares later, total upside is taxed as a capital gain (up to 30%).',
                'id': 'sweden',
            },
            {
                'label': 'Switzerland',
                'tax_lower': 0.3217,
                'tax_higher': 0.4389,
                'discount': 1,
                'description': 'In Switzerland, startups typically use stock options to reward talent. When employees exercise, the upside is taxed as income (up to 53%). If they sell their shares later separately, additional upside is not taxed.',
                'id': 'switzerland',
            },
            {
                'label': 'UK',
                'tax_lower': 0.1,
                'tax_higher': 0.1,
                'discount': 0.2,
                'description': 'In the UK, startups typically use EMI stock options to reward talent. When employees exercise, they are not taxed. When they sell their shares later, total upside is taxed at a reduced capital gains rate of 20%, and often at a special Entrepreneurs&rsquo; Relief rate of 10%. Strike prices 70%+ below last-round valuation are common.',
                'id': 'uk',
            },
            {
                'label': 'US',
                'tax_lower': 0.251,
                'tax_higher': 0.253,
                'discount': 0.4,
                'description': 'In the US, startups typically use ISOs to reward talent. If the employee sells their shares more than one year after exercise and two years after grant, total upside is taxed at a reduced capital gains rate (up to 20%). If the holding requirements are not met, upside is taxed as income (up to 39%). Strike prices 60% below last-round valuation are common.',
                'id': 'us',
            },
        ],
        'funding_rounds': {
            'seed': [
                {
                    'id': 'seed-only',
                    'label': 'Seed only',
                    'typical': '1m on 4m pre',
                    'capital_raised': 0,
                    'pre_money_value': 4000000,
                    'post_money_value': 5000000,
                    'dilution': 0.2,
                    'cum_dilution_after_a': 1,
                    'weight': '0',
                },
                {
                    'id': 'series-a',
                    'label': 'Series A',
                    'typical': '5m on 20m pre',
                    'capital_raised': 20000000,
                    'pre_money_value': 20000000,
                    'post_money_value': 25000000,
                    'dilution': 0.2,
                    'cum_dilution_after_a': 0.8,
                    'weight': '1',
                },
                {
                    'id': 'series-b',
                    'label': 'Series A and B',
                    'typical': '25m on 100m pre',
                    'capital_raised': 50000000,
                    'pre_money_value': 100000000,
                    'post_money_value': 125000000,
                    'dilution': 0.2,
                    'cum_dilution_after_a': 0.67,
                    'weight': '2',
                },
                {
                    'id': 'series-b-and-c',
                    'label': 'Series A, B and C',
                    'typical': '50m on 250m pre',
                    'capital_raised': 100000000,
                    'pre_money_value': 250000000,
                    'post_money_value': 300000000,
                    'dilution': 0.16666666666666666,
                    'cum_dilution_after_a': 0.59,
                    'weight': '3',
                },
                {
                    'id': 'series-b-c-and-d',
                    'label': 'Series A, B, C and D',
                    'typical': '100m on 500m pre',
                    'capital_raised': 200000000,
                    'pre_money_value': 500000000,
                    'post_money_value': 600000000,
                    'dilution': 0.16666666666666666,
                    'cum_dilution_after_a': 0.53,
                    'weight': '4',
                },
            ],
            'venture': [
                {
                    'id': 'series-b',
                    'label': 'Series B',
                    'typical': '25m on 100m pre',
                    'capital_raised': 50000000,
                    'pre_money_value': 100000000,
                    'post_money_value': 125000000,
                    'dilution': 0.2,
                    'cum_dilution_after_a': 0.83,
                    'weight': '2',
                },
                {
                    'id': 'series-b-and-c',
                    'label': 'Series B and C',
                    'typical': '50m on 250m pre',
                    'capital_raised': 100000000,
                    'pre_money_value': 250000000,
                    'post_money_value': 300000000,
                    'dilution': 0.16666666666666666,
                    'cum_dilution_after_a': 0.74,
                    'weight': '3',
                },
                {
                    'id': 'series-b-c-and-d',
                    'label': 'Series B, C and D',
                    'typical': '100m on 500m pre',
                    'capital_raised': 200000000,
                    'pre_money_value': 500000000,
                    'post_money_value': 600000000,
                    'dilution': 0.16666666666666666,
                    'cum_dilution_after_a': 0.66,
                    'weight': '4',
                },
            ],
        },
        'slider_ticks': {
            'estimated_exit_valuation': {
                'full': [
                    0,
                    10000000,
                    25000000,
                    50000000,
                    75000000,
                    100000000,
                    150000000,
                    200000000,
                    250000000,
                    350000000,
                    500000000,
                    750000000,
                    1000000000,
                    1500000000,
                    2000000000,
                    3000000000,
                    4000000000,
                    5000000000,
                    10000000000,
                    20000000000,
                ],
                'reduced': [
                    0,
                    10000000,
                    25000000,
                    50000000,
                    100000000,
                    250000000,
                    350000000,
                    500000000,
                    750000000,
                    1000000000,
                    3500000000,
                    5000000000,
                    10000000000,
                    20000000000,
                ],
            },
        },
        'equity_allocations': {
            '1': {
                'seed': {
                    'id': 1,
                    'label': 'Europe low',
                    'employee': {
                        'tech': {
                            'junior': 0.2,
                            'mid': 0.3,
                            'senior': 0.35,
                        },
                        'non-tech': {
                            'junior': 0.1,
                            'mid': 0.25,
                            'senior': 0.3,

                        },
                    },
                    'executive': {
                        'cxo': {
                            'individual': 0.006,
                        },
                        'vp': {
                            'individual': 0.002,
                        },
                    },
                },
                'venture': {
                    'id': 1,
                    'label': 'Europe low',
                    'employee': {
                        'engineering_devops_ml': {
                            'individual': 0.15,
                            'lead': 0.25,
                            'director': 0.40,
                        },
                        'product_design_bizdev': {
                            'individual': 0.1,
                            'lead': 0.2,
                            'director': 0.3,
                        },
                        'marketing_sales_success_hr_finance': {
                            'individual': 0,
                            'lead': 0.1,
                            'director': 0.2,
                        },
                        'inside_sales_support': {
                            'individual': 0,
                            'lead': 0.05,
                            'director': 0.15,
                        },
                    },
                    'executive': {
                        'cxo': {
                            'individual': 0.006,
                        },
                        'vp': {
                            'individual': 0.0025,
                        },
                    },
                },
            },
            '2': {
                'seed': {
                    'id': 2,
                    'label': 'Europe median',
                    'employee': {
                        'tech': {
                            'junior': 0.3,
                            'mid': 0.4,
                            'senior': 0.5,
                        },
                        'non-tech': {
                            'junior': 0.2,
                            'mid': 0.35,
                            'senior': 0.4,

                        },
                    },
                    'executive': {
                        'cxo': {
                            'individual': 0.008,
                        },
                        'vp': {
                            'individual': 0.003,
                        },
                    },
                },
                'venture': {
                    'id': 2,
                    'label': 'Europe mid / US low',
                    'employee': {
                        'engineering_devops_ml': {
                            'individual': 0.25,
                            'director': 0.5,
                            'lead': 0.35,
                        },
                        'product_design_bizdev': {
                            'individual': 0.15,
                            'lead': 0.25,
                            'director': 0.4,
                        },
                        'marketing_sales_success_hr_finance': {
                            'individual': 0.1,
                            'lead': 0.2,
                            'director': 0.3,
                        },
                        'inside_sales_support': {
                            'individual': 0.05,
                            'lead': 0.15,
                            'director': 0.3,
                        },
                    },
                    'executive': {
                        'cxo': {
                            'individual': 0.008,
                        },
                        'vp': {
                            'individual': 0.0035,
                        },
                    },
                },
            },
            '3': {
                'seed': {
                    'id': 3,
                    'label': 'Europe high',
                    'employee': {
                        'tech': {
                            'junior': 0.45,
                            'mid': 0.55,
                            'senior': 0.7,
                        },
                        'non-tech': {
                            'junior': 0.3,
                            'mid': 0.5,
                            'senior': 0.55,
                        },
                    },
                    'executive': {
                        'cxo': {
                            'individual': 0.01,
                        },
                        'vp': {
                            'individual': 0.004,
                        },
                    },
                },
                'venture': {
                    'id': 3,
                    'label': 'Europe high',
                    'employee': {
                        'engineering_devops_ml': {
                            'individual': 0.40,
                            'lead': 0.5,
                            'director': 0.80,
                        },
                        'product_design_bizdev': {
                            'individual': 0.25,
                            'lead': 0.4,
                            'director': 0.6,
                        },
                        'marketing_sales_success_hr_finance': {
                            'individual': 0.2,
                            'lead': 0.3,
                            'director': 0.45,
                        },
                        'inside_sales_support': {
                            'individual': 0.1,
                            'lead': 0.2,
                            'director': 0.45,
                        },
                    },
                    'executive': {
                        'cxo': {
                            'individual': 0.011,
                        },
                        'vp': {
                            'individual': 0.005,
                        },
                    },
                },
            },
            '4': {
                'seed': {
                    'id': 4,
                    'label': 'US low',
                    'employee': {
                        'tech': {
                            'junior': 0.6,
                            'mid': 0.7,
                            'senior': 0.85,
                        },
                        'non-tech': {
                            'junior': 0.4,
                            'mid': 0.65,
                            'senior': 0.65,
                        },
                    },
                    'executive': {
                        'cxo': {
                            'individual': 0.01,
                        },
                        'vp': {
                            'individual': 0.005,
                        },
                    },
                },
                'venture': {
                    'id': 4,
                    'label': 'US mid',
                    'employee': {
                        'engineering_devops_ml': {
                            'individual': 0.5,
                            'lead': 0.6,
                            'director': 1.05,
                        },
                        'product_design_bizdev': {
                            'individual': 0.35,
                            'lead': 0.5,
                            'director': 0.85,
                        },
                        'marketing_sales_success_hr_finance': {
                            'individual': 0.25,
                            'lead': 0.40,
                            'director': 0.6,
                        },
                        'inside_sales_support': {
                            'individual': 0.15,
                            'lead': 0.3,
                            'director': 0.55,
                        },
                    },
                    'executive': {
                        'cxo': {
                            'individual': 0.014,
                        },
                        'vp': {
                            'individual': 0.007,
                        },
                    },
                },
            },
            '5': {
                'seed': {
                    'id': 5,
                    'label': 'US median',
                    'employee': {
                        'tech': {
                            'junior': 0.7,
                            'mid': 0.85,
                            'senior': 0.95,
                        },
                        'non-tech': {
                            'junior': 0.45,
                            'mid': 0.75,
                            'senior': 0.75,
                        },
                    },
                    'executive': {
                        'cxo': {
                            'individual': 0.011000000000000001,
                        },
                        'vp': {
                            'individual': 0.006,
                        },
                    },
                },
                'venture': {
                    'id': 5,
                    'label': 'US high',
                    'employee': {
                        'engineering_devops_ml': {
                            'individual': 0.7,
                            'lead': 0.9,
                            'director': 1.6,
                        },
                        'product_design_bizdev': {
                            'individual': 0.5,
                            'lead': 0.70,
                            'director': 1.05,
                        },
                        'marketing_sales_success_hr_finance': {
                            'individual': 0.35,
                            'lead': 0.55,
                            'director': 0.9,
                        },
                        'inside_sales_support': {
                            'individual': 0.20,
                            'lead': 0.45,
                            'director': 0.75,
                        },
                    },
                    'executive': {
                        'cxo': {
                            'individual': 0.02,
                        },
                        'vp': {
                            'individual': 0.01,
                        },
                    },
                },
            },
            '6': {
                'seed': {
                    'id': 6,
                    'label': 'US high',
                    'employee': {
                        'tech': {
                            'junior': 0.9,
                            'mid': 1.1,
                            'senior': 1.35,
                        },
                        'non-tech': {
                            'junior': 0.5,
                            'mid': 0.8,
                            'senior': 0.85,
                        },
                    },
                    'executive': {
                        'cxo': {
                            'individual': 0.012,
                        },
                        'vp': {
                            'individual': 0.006500000000000001,
                        },
                    },
                },
                'venture': {
                    'id': 6,
                    'label': 'US very high',
                    'employee': {
                        'engineering_devops_ml': {
                            'individual': 0.85,
                            'lead': 1.2,
                            'director': 2.2,
                        },
                        'product_design_bizdev': {
                            'individual': 0.65,
                            'lead': 0.90,
                            'director': 1.25,
                        },
                        'marketing_sales_success_hr_finance': {
                            'individual': 0.4,
                            'lead': 0.65,
                            'director': 1.15,
                        },
                        'inside_sales_support': {
                            'individual': 0.3,
                            'lead': 0.6,
                            'director': 0.95,
                        },
                    },
                    'executive': {
                        'cxo': {
                            'individual': 0.03,
                        },
                        'vp': {
                            'individual': 0.015,
                        },
                    },
                },
            },
        },
        'equity_allocation_level': {
            seed: {
                '1': {
                    'label': 'Very low',
                },
                '2': {
                    'label': 'Low',
                },
                '3': {
                    'label': 'Below average',
                },
                '4': {
                    'label': 'Above average',
                },
                '5': {
                    'label': 'High',
                },
                '6': {
                    'label': 'Very high',
                },
            },
            venture: {
                '1': {
                    'label': 'Very low',
                },
                '2': {
                    'label': 'Low',
                },
                '3': {
                    'label': 'Below mid',
                },
                '4': {
                    'label': 'Above mid',
                },
                '5': {
                    'label': 'High',
                },
                '6': {
                    'label': 'Very high',
                },
            },
        },
    },
    'input_defaults': {
        'seed': {
            'hiring_plans': {
                'employee': {
                    'tech': {
                        'counts': {
                            'junior': '3',
                            'mid': '3',
                            'senior': '3',
                        },
                        'salaries': {
                            '1': {
                                'junior': 45000,
                                'mid': 65000,
                                'senior': 85000,
                            },
                            '2': {
                                'junior': 60000,
                                'mid': 75000,
                                'senior': 95000,
                            },
                            '3': {
                                'junior': 85000,
                                'mid': 110000,
                                'senior': 140000,
                            },
                            '4': {
                                'junior': 90000,
                                'mid': 125000,
                                'senior': 165000,
                            },
                            '5': {
                                'junior': 100000,
                                'mid': 135000,
                                'senior': 185000,
                            },
                            '6': {
                                'junior': 125000,
                                'mid': 175000,
                                'senior': 210000,
                            },
                        },
                    },
                    'non-tech': {
                        'counts': {
                            'junior': '1',
                            'mid': '2',
                            'senior': '0',
                        },
                        'salaries': {
                            '1': {
                                'junior': 35000,
                                'mid': 55000,
                                'senior': 60000,
                            },
                            '2': {
                                'junior': 55000,
                                'mid': 65000,
                                'senior': 80000,
                            },
                            '3': {
                                'junior': 60000,
                                'mid': 80000,
                                'senior': 100000,
                            },
                            '4': {
                                'junior': 55000,
                                'mid': 90000,
                                'senior': 110000,
                            },
                            '5': {
                                'junior': 65000,
                                'mid': 100000,
                                'senior': 125000,
                            },
                            '6': {
                                'junior': 75000,
                                'mid': 125000,
                                'senior': 165000,
                            },
                        },
                    },
                },
                'executive': {
                    'cxo': {
                        'counts': {
                            'individual': 0,
                        },
                        'label': null,
                    },
                    'vp': {
                        'counts': {
                            'individual': 0,
                        },
                        'label': null,
                    },
                },
            },
            'pre_funding_valuation': 20000000,
            'initial_amount_raised': 4000000,
            'expected_funding_rounds_pre_exit': 'series-b-and-c',
            'estimated_exit_valuation': 1000000000,
            'initial_equity_allocated': 0,
            'employees_pre_funding': 10,
            'employee_country': 'us',
            'salary_allocation_level': 5,
            'esop_contingency': 0.02,
            'equity_allocation_level': 4,
        },
        'venture': {
            'hiring_plans': {
                'employee': {
                    'engineering_devops_ml': {
                        'counts': {
                            'individual': '12',
                            'lead': '9',
                            'director': '2',
                        },
                        'salaries': {
                            '1': {
                                'individual': 50000,
                                'lead': 75000,
                                'director': 110000,
                            },
                            '2': {
                                'individual': 90000,
                                'lead': 115000,
                                'director': 130000,
                            },
                            '3': {
                                'individual': 100000,
                                'lead': 145000,
                                'director': 180000,
                            },
                            '4': {
                                'individual': 120000,
                                'lead': 160000,
                                'director': 200000,
                            },
                            '5': {
                                'individual': 130000,
                                'lead': 175000,
                                'director': 215000,
                            },
                            '6': {
                                'individual': 140000,
                                'lead': 185000,
                                'director': 225000,
                            },
                        },
                    },
                    'product_design_bizdev': {
                        'counts': {
                            'individual': 5,
                            'lead': 5,
                            'director': 2,
                        },
                        'salaries': {
                            '1': {
                                'individual': 50000,
                                'lead': 75000,
                                'director': 105000,
                            },
                            '2': {
                                'individual': 70000,
                                'lead': 100000,
                                'director': 150000,
                            },
                            '3': {
                                'individual': 95000,
                                'lead': 140000,
                                'director': 165000,
                            },
                            '4': {
                                'individual': 110000,
                                'lead': 150000,
                                'director': 190000,
                            },
                            '5': {
                                'individual': 120000,
                                'lead': 140000,
                                'director': 195000,
                            },
                            '6': {
                                'individual': 130000,
                                'lead': 180000,
                                'director': 215000,
                            },
                        },
                    },
                    'marketing_sales_success_hr_finance': {
                        'counts': {
                            'individual': '6',
                            'lead': '6',
                            'director': '3',
                        },
                        'salaries': {
                            '1': {
                                'individual': 50000,
                                'lead': 65000,
                                'director': 100000,
                            },
                            '2': {
                                'individual': 60000,
                                'lead': 85000,
                                'director': 125000,
                            },
                            '3': {
                                'individual': 85000,
                                'lead': 120000,
                                'director': 160000,
                            },
                            '4': {
                                'individual': 100000,
                                'lead': 125000,
                                'director': 160000,
                            },
                            '5': {
                                'individual': 120000,
                                'lead': 140000,
                                'director': 175000,
                            },
                            '6': {
                                'individual': 130000,
                                'lead': 155000,
                                'director': 200000,
                            },
                        },
                    },
                    'inside_sales_support': {
                        'counts': {
                            'individual': '5',
                            'lead': '1',
                            'director': '0',
                        },
                        'salaries': {
                            '1': {
                                'individual': 40000,
                                'lead': 50000,
                                'director': 70000,
                            },
                            '2': {
                                'individual': 45000,
                                'lead': 65000,
                                'director': 85000,
                            },
                            '3': {
                                'individual': 55000,
                                'lead': 95000,
                                'director': 105000,
                            },
                            '4': {
                                'individual': 75000,
                                'lead': 95000,
                                'director': 125000,
                            },
                            '5': {
                                'individual': 85000,
                                'lead': 115000,
                                'director': 150000,
                            },
                            '6': {
                                'individual': 95000,
                                'lead': 125000,
                                'director': 170000,
                            },
                        },
                    },
                },
                'executive': {
                    'vp': {
                        'counts': {
                            'individual': '3',
                        },
                    },
                    'cxo': {
                        'counts': {
                            'individual': '1',
                        },
                    },
                },
            },
            'pre_funding_valuation': 80000000,
            'initial_amount_raised': 20000000,
            'expected_funding_rounds_pre_exit': 'series-b-and-c',
            'estimated_exit_valuation': 1000000000,
            'initial_equity_allocated': 0.055,
            'employees_pre_funding': 10,
            'employee_country': 'us',
            'salary_allocation_level': 5,
            'esop_contingency': 0.02,
            'equity_allocation_level': 4,
        },
    },
    text: {
        'seed': {
            'introduction': '<p>Entrepreneurs know how important stock options are for hiring and retaining the best talent. But to create an effective option plan you need to know how much to award to each team member. We compiled the largest ever set of benchmark data, comprising over 20,000 option grants from more than 1,650 startups across the US&nbsp;and Europe. We want to help you get this right.</p>\r\n',
            'assumptions': '<p><strong>1/ General Assumptions</strong></p>\r\n\r\n<ul>\r\n\t<li>\r\n\t<p>The Seed model is purely for calculating option grants made to employees after seed fundraising, and before Series A.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>The Venture model is purely for calculating option grants made to employees after Series A fundraising, and before Series B.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Option holders are still employees at the point of exit, with fully vested grants.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>No further option grants are made to these employees.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Option holders exercise all their options within one tax year.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Series A dilution assumes a $20m fundraise at a $80m pre-money valuation (Seed model only).</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Series B dilution assumes a $50m fundraise at a $250m pre-money valuation.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Series C dilution assumes a $100m fundraise at a $750m pre-money valuation.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Series D dilution assumes a $200m fundraise at a $1.8 billion pre-money valuation.</p>\r\n\t</li>\r\n</ul>\r\n\r\n<p><strong>2/ Tax assumptions</strong></p>\r\n\r\n<ul>\r\n\t<li>\r\n\t<p>Tax regimes, social&nbsp;charges (health, social security etc), and currency exchange rates correct as of November 2018.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Strike price discounts applied for each country reflect common practice by startups and tax authorities.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Options are granted under the most favorable scheme in place in that country at the point of grant.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Calculations assume the most beneficial tax outcome - in some countries, exercise and sale of stock options happens simultaneously. In others, there is a holding period assumed before sale (see country specific assumptions).</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Where relevant, capital gains allowances have been taken into account (see country specific assumptions).</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Tax rates assume no other deductions or sources of income or capital gain for the individual.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Tax rates for Executives, and for Directors (engineering, devops, ML) assume a salary of $150,000.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Tax rates for all other roles, including all Seed roles, assume a $50,000 salary.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>For countries where it makes a difference, assume $50,000 gross upside from options (see country specific assumptions).</p>\r\n\t</li>\r\n</ul>\r\n\r\n<p><strong>3/ Country-specific tax assumptions</strong></p>\r\n',
            'assumptions_part2': '<p><strong>Australia</strong><br />\r\nTax favourable scheme used and all requirements met including that employees must hold options or shares for at least 3 years<br />\r\nStrike price is 40% of last round valuation</p>\r\n\r\n<p><strong>Austria</strong><br />\r\nVirtual stock options used<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Belgium</strong><br />\r\nWarrants used<br />\r\nTax at grant<br />\r\nEmployee commits not to exercise the warrants within a period of 3 years following the grant, so 9% (rather than 18%) is taxed at income rates<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Canada</strong><br />\r\nStock options used<br />\r\nSale is more than 2 years after exercise, so C$850k is entirely tax free<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 40% of last round valuation</p>\r\n\r\n<p><strong>Czech Republic</strong><br />\r\nVirtual stock options used<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Denmark</strong><br />\r\nWarrants used<br />\r\nSimultaneous exercise and sale<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Estonia</strong><br />\r\nStrike price is 40% of last round valuation</p>\r\n\r\n<p><strong>Finland</strong><br />\r\nStandard stock options used<br />\r\nSimultaneous exercise and sale<br />\r\nAssumes $50,000 upside from stock options<br />\r\nAssumes Helsinki taxes<br />\r\nIgnores pension and unemployment<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>France</strong><br />\r\nBSPCE used and all requirements met<br />\r\nEmployee\'s tenure is more than 3 years at date of sale, so reduced 19% tax rate applies<br />\r\nStrike price is 80% of last round valuation</p>\r\n\r\n<p><strong>Germany</strong><br />\r\nVirtual stock options used<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Ireland</strong><br />\r\nKEEP used and all requirements met<br />\r\nIncludes capital gains allowance<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Israel</strong><br />\r\nStock options issued in capital gains track and all requirements met<br />\r\nOptions are held in approved trust scheme for 2 years following grant<br />\r\nStrike price is 40% of last round valuation</p>\r\n\r\n<p><strong>Italy</strong><br />\r\nInnovative startups scheme used and all requirements met<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Netherlands</strong><br />\r\nStandard stock options used<br />\r\nSimultaneous exercise and sale<br />\r\nIncludes 25% of the gain at exercise being non-taxable<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Norway</strong><br />\r\nShare purchase plan used<br />\r\nSimultaneous exercise and sale<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 80% of last round valuation</p>\r\n\r\n<p><strong>Poland</strong><br />\r\nStock options used<br />\r\nIssuing entity must be an EU/EEA Joint Stock company or from a jurisdiction where Poland has a tax treaty so capital gains rates apply<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Portugal</strong><br />\r\nVirtual stock options used<br />\r\nSmall company requirements met so 14% rate applies<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Spain</strong><br />\r\nVirtual stock options used<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Sweden</strong><br />\r\nQESO used and all requirements met including employees remaining with the company for 3 years post grant<br />\r\nStrike price is 20% of last round valuation</p>\r\n\r\n<p><strong>Switzerland</strong><br />\r\nStandard stock options used<br />\r\nAssumes $50,000 upside from stock options<br />\r\nAssumes Zurich taxes<br />\r\nSingle taxpayer, no children<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>UK</strong><br />\r\nEMI used and all requirements met<br />\r\nOptions held for more than 2 years between grant and sale, so 10% tax rate applied (Entrepreneurs\' relief)<br />\r\nIncludes capital gains allowance<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 20% of last round valuation</p>\r\n\r\n<p><strong>US</strong><br />\r\nISO used and all requirements met<br />\r\nOptions held for more than one year after exercise and two years after grant, so treated as long term capital gain tax<br />\r\nCalculation includes federal, state and local taxes<br />\r\nAssumes single taxpayer, no children<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 40% of last round valuation</p>\r\n',
            'valuation_less_than_total_fundraising': '<p>You\'ve selected an exit valuation that\'s less than the total capital you are likely to have raised. It\'s unlikely in this case that option holders will receive anything. Raise your exit valuation, or lower your additional funding (qu 3).</p>\r\n',
            'valuation_less_than_initial_funding': '<p>You\'ve selected an exit valuation that\'s lower than your Series A valuation post-funding. It\'s likely in this scenario that option holders will see little or no financial upside. Raise your exit valuation, or lower your Series A valuation.</p>\r\n',
            'valuation_over_ambitious': '<p>You\'ve selected an exit valuation that\'s very ambitious given your level of additional funding in question 3. Either reduce your exit valuation, or increase your additional funding.</p>\r\n',
            'ownership_percentages_overwritten': '<p>The Ownership (%) values that you manually added have been over-written by the benchmark values.</p>\r\n',
            'pre_funding_valuation': '<p>This app is designed for companies at, or approaching, seed funding. We\'re asking here for your seed valuation pre-funding.<br />\r\nA pre-funding valuation of $20m is typical for the US, and $15m for Europe.</p>\r\n',
            'initial_amount_raised': '<p>A typical seed might raise $4m in the US, and $3m in Europe. Adding your seed funding to your pre-funding valuation gives your post-funding seed valuation, used for calculating option grants later in this app.</p>\r\n',
            'expected_funding_rounds_pre_exit': '<p>When you raise additional capital, pre-existing shareholders and option holders are diluted. This dilution is proportional to the amount of capital raised, and inversely proportional to the company valuation you achieve. In successful companies, valuation increases outstrip dilution with each new fundraise.</p>\r\n\r\n<p>For more on the impact of dilution, check out this&nbsp;<a href="/rewarding-talent/the-impact-of-dilution">section</a> in our handbook.</p>\r\n',
            'estimated_exit_valuation': '<p>How valuable do you think your company could ultimately be, when you either sell it, or go public via an IPO? This exit valuation determines the upside for option holders too. But it is also likely to require further fundraising beyond your seed round. So make sure that your answer to question 3 is realistic.</p>\r\n',
            'initial_equity_allocated': '<p>NA</p>\r\n',
            'employee_country': '<p>Your country determines the amount of tax and social charges employees will pay on their stock options when they exercise and sell their shares. It varies widely from country to country.</p>\r\n\r\n<p>For more detail on how legal and tax rules affect stock options in different countries, check out <a href="/rewarding-talent/country-by-country-review">chapter 7</a> of our handbook.</p>\r\n',
            'salary_allocation_level': '<p>Salaries at seed stage vary widely across the US, and between the US and Europe, due to talent market squeeze, and cash constraints.</p>\r\n\r\n<p>For example, \'US high\' level most closely reflects the Bay Area, and \'Europe high\' reflects major European tech hubs.</p>\r\n\r\n<p>For more information on the factors that drive salary levels at seed, check out the seed allocation <a href="/rewarding-talent/allocation-considerations-and-benchmarks">section</a> of our handbook.</p>\r\n',
            'equity_allocation_level': '<p>The more technical your company challenges are, the more specialist talent you will require. This will mean providing higher equity offers to attract the best team.</p>\r\n\r\n<p>For more details on technical DNA, check out this <a href="/rewarding-talent/esop-size-at-seed">section</a> of our handbook.</p>\r\n',
            'hiring_plans_employee': '<p>With seed rounds now getting larger, we suggest calculating option grants as a % of base salary. This % will vary by seniority and technicality. In the US grants are usually made at the point of hire, but this is often not the case in Europe.</p>\r\n\r\n<p>For more information on benchmark grants, check out the seed allocation <a href="/rewarding-talent/allocation-considerations-and-benchmarks">section</a> of our handbook.</p>\r\n',
            'hiring_plans': '<p>Following your seed round, you\'ll hire a small team (average of twelve) to propel you to your next milestone.</p>\r\n\r\n<p>Our benchmark data suggests an average of 12 employees split across seniority and technicality but this will differ from company to company.</p>\r\n',
            'option_pool_required': '<p>This is the sum of&nbsp;all the option grants made to your hires following seed funding. You need to make sure that your ESOP pool at seed stage is sufficiently large. Typically it is 10%, although it can be 15% or even 20% in some cases.</p>\r\n\r\n<p>Check out this <a href="/rewarding-talent/esop-size-at-seed">section</a> of our handbook for more on ESOP size at seed.</p>\r\n',
            'employee_upside_summary': '<p>For the hires you plan to make following your seed round, this indicates the upside (before tax) they might make from their stock options, at each level of seniority. Adjust the exit valuation slider below to see how this affects upside.</p>\r\n',
            'employee_upside_by_type_role': '<p>Tax calculations are complex, and we have simplified. See our Assumptions list for more details. Adjust the exit valuation slider above to see how this affects upside net of tax.</p>\r\n',
        },
        'venture': {
            'introduction': '<p>Entrepreneurs know how important stock options are for hiring and retaining the best talent. But to create an effective option plan you need to know how much to award to each team member. We compiled the largest ever set of benchmark data, comprising over 20,000 option grants from more than 1,650 startups across the US&nbsp;and Europe. We want to help you get this right.</p>\r\n',
            'assumptions': '<p><strong>1/ General Assumptions</strong></p>\r\n\r\n<ul>\r\n\t<li>\r\n\t<p>The Seed model is purely for calculating option grants made to employees after seed fundraising, and before Series A.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>The Venture model is purely for calculating option grants made to employees after Series A fundraising, and before Series B.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Option holders are still employees at the point of exit, with fully vested grants.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>No further option grants are made to these employees.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Option holders exercise all their options within one tax year.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Series A dilution assumes a $20m fundraise at a $80m pre-money valuation (Seed model only).</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Series B dilution assumes a $50m fundraise at a $250m pre-money valuation.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Series C dilution assumes a $100m fundraise at a $750m pre-money valuation.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Series D dilution assumes a $200m fundraise at a $1.8 billion pre-money valuation.</p>\r\n\t</li>\r\n</ul>\r\n\r\n<p><strong>2/ Tax assumptions</strong></p>\r\n\r\n<ul>\r\n\t<li>\r\n\t<p>Tax regimes, social&nbsp;charges (health, social security etc), and currency exchange rates correct as of November 2018.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Strike price discounts applied for each country reflect common practice by startups and tax authorities.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Options are granted under the most favorable scheme in place in that country at the point of grant.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Calculations assume the most beneficial tax outcome - in some countries, exercise and sale of stock options happens simultaneously. In others, there is a holding period assumed before sale (see country specific assumptions).</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Where relevant, capital gains allowances have been taken into account (see country specific assumptions).</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Tax rates assume no other deductions or sources of income or capital gain for the individual.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Tax rates for Executives, and for Directors (engineering, devops, ML) assume a salary of $150,000.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>Tax rates for all other roles, including all Seed roles, assume a $50,000 salary.</p>\r\n\t</li>\r\n\t<li>\r\n\t<p>For countries where it makes a difference, assume $50,000 gross upside from options (see country specific assumptions).</p>\r\n\t</li>\r\n</ul>\r\n\r\n<p><strong>3/ Country-specific tax assumptions</strong></p>\r\n',
            'assumptions_part2': '<p><strong>Australia</strong><br />\r\nTax favourable scheme used and all requirements met including that employees must hold options or shares for at least 3 years<br />\r\nStrike price is 40% of last round valuation</p>\r\n\r\n<p><strong>Austria</strong><br />\r\nVirtual stock options used<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Belgium</strong><br />\r\nWarrants used<br />\r\nTax at grant<br />\r\nEmployee commits not to exercise the warrants within a period of 3 years following the grant, so 9% (rather than 18%) is taxed at income rates<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Canada</strong><br />\r\nStock options used<br />\r\nSale is more than 2 years after exercise, so C$850k is entirely tax free<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 40% of last round valuation</p>\r\n\r\n<p><strong>Czech Republic</strong><br />\r\nVirtual stock options used<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Denmark</strong><br />\r\nWarrants used<br />\r\nSimultaneous exercise and sale<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Estonia</strong><br />\r\nStrike price is 40% of last round valuation</p>\r\n\r\n<p><strong>Finland</strong><br />\r\nStandard stock options used<br />\r\nSimultaneous exercise and sale<br />\r\nAssumes $50,000 upside from stock options<br />\r\nAssumes Helsinki taxes<br />\r\nIgnores pension and unemployment<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>France</strong><br />\r\nBSPCE used and all requirements met<br />\r\nEmployee\'s tenure is more than 3 years at date of sale, so reduced 19% tax rate applies<br />\r\nStrike price is 80% of last round valuation</p>\r\n\r\n<p><strong>Germany</strong><br />\r\nVirtual stock options used<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Ireland</strong><br />\r\nKEEP used and all requirements met<br />\r\nIncludes capital gains allowance<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Israel</strong><br />\r\nStock options issued in capital gains track and all requirements met<br />\r\nOptions are held in approved trust scheme for 2 years following grant<br />\r\nStrike price is 40% of last round valuation</p>\r\n\r\n<p><strong>Italy</strong><br />\r\nInnovative startups scheme used and all requirements met<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Netherlands</strong><br />\r\nStandard stock options used<br />\r\nSimultaneous exercise and sale<br />\r\nIncludes 25% of the gain at exercise being non-taxable<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Norway</strong><br />\r\nShare purchase plan used<br />\r\nSimultaneous exercise and sale<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 80% of last round valuation</p>\r\n\r\n<p><strong>Poland</strong><br />\r\nStock options used<br />\r\nIssuing entity must be an EU/EEA Joint Stock company or from a jurisdiction where Poland has a tax treaty so capital gains rates apply<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Portugal</strong><br />\r\nVirtual stock options used<br />\r\nSmall company requirements met so 14% rate applies<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Spain</strong><br />\r\nVirtual stock options used<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>Sweden</strong><br />\r\nQESO used and all requirements met including employees remaining with the company for 3 years post grant<br />\r\nStrike price is 20% of last round valuation</p>\r\n\r\n<p><strong>Switzerland</strong><br />\r\nStandard stock options used<br />\r\nAssumes $50,000 upside from stock options<br />\r\nAssumes Zurich taxes<br />\r\nSingle taxpayer, no children<br />\r\nStrike price is 100% of last round valuation</p>\r\n\r\n<p><strong>UK</strong><br />\r\nEMI used and all requirements met<br />\r\nOptions held for more than 2 years between grant and sale, so 10% tax rate applied (Entrepreneurs\' relief)<br />\r\nIncludes capital gains allowance<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 20% of last round valuation</p>\r\n\r\n<p><strong>US</strong><br />\r\nISO used and all requirements met<br />\r\nOptions held for more than one year after exercise and two years after grant, so treated as long term capital gain tax<br />\r\nCalculation includes federal, state and local taxes<br />\r\nAssumes single taxpayer, no children<br />\r\nAssumes $50,000 upside from stock options<br />\r\nStrike price is 40% of last round valuation</p>\r\n',
            'valuation_less_than_total_fundraising': '<p>You\'ve selected an exit valuation that\'s less than the total capital you are likely to have raised. It\'s unlikely in this case that option holders will receive anything. Raise your exit valuation, or lower your additional funding (qu 3).</p>\r\n',
            'valuation_less_than_initial_funding': '<p>You\'ve selected an exit valuation that\'s lower than your Series A valuation post-funding. It\'s likely in this scenario that option holders will see little or no financial upside. Raise your exit valuation, or lower your Series A valuation.</p>\r\n',
            'valuation_over_ambitious': '<p>You\'ve selected an exit valuation that\'s very ambitious given your level of additional funding in question 3. Either reduce your exit valuation, or increase your additional funding.</p>\r\n',
            'ownership_percentages_overwritten': '<p>The Ownership (%) values that you manually added have been over-written by the benchmark values.</p>\r\n',
            'pre_funding_valuation': '<p>This app is designed for companies at, or approaching, Series A funding. We\'re asking here for your Series A valuation pre-funding.</p>\r\n\r\n<p>A pre-funding valuation of $80m is now typical for the US, and $60m for Europe</p>\r\n',
            'initial_amount_raised': '<p>A typical Series. might raise $20m in the US now, and $15m in Europe. Adding your Series A funding to your pre-funding valuation gives your post-funding Series A valuation, used for calculating option grants later in this app.</p>\r\n',
            'expected_funding_rounds_pre_exit': '<p>When you raise additional capital, pre-existing shareholders and option holders are diluted. This dilution is proportional to the amount of capital raised, and inversely proportional to the company valuation you achieve. In successful companies, valuation increases outstrip dilution with each new fundraise.</p>\r\n\r\n<p>For more on the impact of dilution, check out this <a href="/rewarding-talent/the-impact-of-dilution">section</a>&nbsp;in our handbook.</p>\r\n',
            'estimated_exit_valuation': '<p>How valuable do you think your company could ultimately be, when you either sell it, or go public via an IPO? This exit valuation determines the upside for option holders too. But it is also likely to require further fundraising beyond your Series A. So make sure that your answer to question 3 is realistic.</p>\r\n',
            'initial_equity_allocated': '<p>Before your Series A you may have started making option grants - or informal promises - to your early team members. Our research suggests that on average in the US, 5-6% of fully diluted equity will have been granted or promised to this early team. In Europe it\'s 4-5%. But this figure can vary a lot.</p>\r\n\r\n<p>For more on option grants for early team members, check out <a href="/rewarding-talent/option-grants-at-seed">chapter 5</a> of our handbook.</p>\r\n',
            'employee_country': '<p>Your country determines how much tax employees will pay on their stock options when they exercise and sell their shares. It varies widely from country to country.</p>\r\n\r\n<p>For more detail on how legal and tax rules affect stock options in different countries, check out <a href="/rewarding-talent/country-by-country-review">chapter 7</a>&nbsp;of our handbook.</p>\r\n',
            'salary_allocation_level': '<p>How much equity you offer to employees depends on several factors. For technical hires, how much technical DNA does your product need? The greater your technical challenges, the more specialist talent you\'ll need. Geography also matters - the US and Bay Area in particular has higher equity norms. Your compensation philosophy will also have an impact here.</p>\r\n\r\n<p>For more information on the factors that drive option allocation levels, check out this <a href="/rewarding-talent/esop-size-at-series-a-and-beyond">section</a> of our handbook.</p>\r\n',
            'hiring_plans_executive': '<p>Following your Series A, you\'ll make your first few executive level hires. We recommend calculating executive grants as a percentage of total company shares (FDE). Grants for executives are usually made at the point of hire.</p>\r\n\r\n<p>For more information on benchmark grants, check out&nbsp;<a href="/rewarding-talent/option-grants-at-series-a">chapter 6</a>&nbsp;of our handbook.</p>\r\n',
            'hiring_plans_employee': '<p>Between your Series A and Series B fundraises, you\'ll build out your team - with 50 hires being typical. Below executive level, we recommend calculating grants as a % of base salary. This % will vary by seniority and function. In the US grants are usually made at the point of hire, but this is often not the case in Europe.</p>\r\n\r\n<p>For more information on benchmark grants, check out <a href="/rewarding-talent/option-grants-at-series-a">chapter 6</a> of our handbook.</p>\r\n',
            'option_pool_required': '<p>Your total Series A option pool should be the sum of grants made to hires pre-Series A, plus the grants you expect to make for hires after Series A. We recommend adding a 2% contingency buffer, to cover any additional or exceptional hires you may want to make.</p>\r\n\r\n<p>Check out this <a href="/rewarding-talent/esop-size">section</a> of our handbook for more on ESOP size.</p>\r\n',
            'employee_upside_summary': '<p>For the hires you plan to make following Series A, this indicates the upside (before tax) they might make from their stock options, at each level of seniority. Adjust the exit valuation slider below to see how this affects upside.</p>\r\n',
            'executive_upside_by_role': '<p>Tax calculations are complex, and we have simplified. See our Assumptions list for more details.</p>\r\n\r\n<p>Adjust the exit valuation slider above to see how this affects upside.</p>\r\n',
            'employee_upside_by_type_role': '<p>Tax calculations are complex, and we have simplified. See our Assumptions list for more details.</p>\r\n\r\n<p>Adjust the exit valuation slider above to see how this affects upside.</p>\r\n',
            'equity_allocation_level': '<p>Salaries at Series A vary widely across the US, and between the US and Europe, due to talent market squeeze, and cash constraints.</p>\r\n\r\n<p>For example, "US very high" level most closely reflects the Bay Area, and "Europe high" reflects major European tech hubs.</p>\r\n\r\n<p>For more details on equity allocation levels, check out this <a href="/rewarding-talent/esop-size-at-seed">section</a> of our handbook.</p>\r\n',
        },
    },
    sectors: {
        'engineering_devops_ml': {label: 'Engineering, DevOps, ML'},
        'product_design_bizdev': {label: 'Product, Design, BizDev'},
        'marketing_sales_success_hr_finance': {label: 'Marketing, Sales, Success, HR, Finance'},
        'inside_sales_support': {label: 'Inside Sales, Support'},
        tech: {label: 'Tech'},
        'non-tech': {label: 'Non-tech'},
        cxo: {label: 'C-Suite'},
        vp: {label: 'VP'},
    },
    roles: {
        cxo: {label: 'C-Suite', limits: {hires: 5, ownership: 10}},
        vp: {label: 'VP', limits: {hires: 10, ownership: 5}},
        director: {label: 'Director', limits: {hires: 5, salary: 500000, ownership: 500}},
        lead: {label: 'Senior', limits: {hires: 20, salary: 500000, ownership: 500}},
        individual: {label: 'Individual', limits: {hires: 50, salary: 500000, ownership: 500}},
        junior: {label: 'Junior', limits: {hires: 50, salary: 150000, ownership: 500}},
        mid: {label: 'Mid-level', limits: {hires: 25, salary: 200000, ownership: 500}},
        senior: {label: 'Senior', limits: {hires: 20, salary: 250000, ownership: 500}},
    },
    'role_order': {
        seed: {
            employee: ['senior', 'mid', 'junior'],
            executive: ['cxo', 'vp'],
        },
        venture: {
            employee: ['director', 'lead', 'individual'],
            executive: ['cxo', 'vp'],
        },
    },
    'theme_path': '/static',
    // @todo: js 'theme_path': env("STATIC_URL", default="/static/"),
    questions: {
        'seed': {
            'q3': 'Expected additional funding before exit',
            'q4': 'Exit valuation aspiration',
            'ab': 'Employee upside summary, pre-tax',
            'q1': 'Seed valuation',
            'q1_max': 40000000,
            'q1_eu': 15000000,
            'q1_us': 20000000,
            'q2': 'Seed funding goal',
            'q2_max': 8000000,
            'q2_eu': 3000000,
            'q2_us': 4000000,
            'q5': 'Country',
            'q6': 'Geography - determines salary level',
            'q7': 'Technical DNA - determines option allocation level',
            'q8': 'Hiring plan (Up to Series A)',
            'q9': 'Compensation per hire - cash and equity summary',
            'aa': 'Total options granted to post-seed hires',
            'ac': 'Seed team upside: pre and post-tax',
        },
        'venture': {
            'q3': 'Expected additional funding before exit',
            'q4': 'Exit valuation aspiration',
            'ab': 'Employee upside summary, pre-tax',
            'q1': 'Series A valuation',
            'q1_max': 150000000,
            'q1_eu': 60000000,
            'q1_us': 80000000,
            'q2': 'Series A funding goal',
            'q2_max': 30000000,
            'q2_eu': 15000000,
            'q2_us': 20000000,
            'q5': 'Stock options awarded to pre-Series A employees',
            'q6': 'Country',
            'q7': 'Geography - determines salary level',
            'q8': 'Equity allocation level',
            'q9': 'Executive hires (up to Series B)',
            'q10': 'Other employee hires (up to Series B)',
            'aa': 'Total option pool (ESOP) required',
            'ac': 'Executive upside: pre and post-tax',
            'ad': 'Employee upside: pre and post-tax',
        },
    },
    embedded: false,
}
